var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import mediaQueries from "syf-component-library/const/mediaQueries";
export var RowItem = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: column;\n  flex: 50%;\n"], ["\n  flex-direction: column;\n  flex: 50%;\n"])));
export var FieldValue = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: bold;\n\n  @media ", " {\n    font-size: 16px;\n  }\n"], ["\n  font-weight: bold;\n\n  @media ", " {\n    font-size: 16px;\n  }\n"])), mediaQueries.lessThanMedium);
var templateObject_1, templateObject_2;
